(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9108],{

/***/ 89866:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/policies/payment-guide",
      function () {
        return __webpack_require__(78861);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 78861:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _components_ui_MetaTag__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(42031);



var PaymentGuidePolicyPage = function() {
    var companyName = "https://anthu.vn";
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_ui_MetaTag__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                title: "H\xecnh thức thanh to\xe1n",
                description: "H\xecnh thức thanh to\xe1n"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "container tw-mx-auto md:tw-border-t tw-border-primary-main tw-pt-8 tw-pb-10",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "tw-flex tw-gap-y-1 tw-flex-col tw-leading-7",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                            className: "tw-text-center tw-font-bold tw-text-lg lg:tw-text-2xl tw-mb-5 tw-uppercase",
                            children: "H\xecnh thức thanh to\xe1n"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("h5", {
                            className: "tw-font-semibold ",
                            children: [
                                companyName,
                                " cung cấp 2 loại thanh to\xe1n sau:"
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "tw-flex tw-flex-col tw-space-y-2",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                    children: "- Thanh to\xe1n khi nhận h\xe0ng (COD) - Chỉ \xe1p dụng đối với đơn h\xe0ng nội th\xe0nh HCM."
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                    children: "- Chuyển khoản qua ng\xe2n h\xe0ng."
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                    children: [
                                        "- Thanh to\xe1n bằng ATD: để thuận tiện cho việc mua h\xe0ng v\xe0 thanh to\xe1n, qu\xfd kh\xe1ch h\xe0ng c\xf3 thể tiến h\xe0nh nạp tiền v\xe0o t\xe0i khoản đ\xe3 đăng k\xfd tại ",
                                        companyName,
                                        " với tỷ lệ quy đổi:",
                                        " "
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                    className: "tw-text-center tw-font-semibold ",
                                    children: "100.000 VNĐ = 01 ATD"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                    children: "Thời gian x\xe1c nhận thanh to\xe1n bằng ATD tối đa trong 24h."
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                    children: "H\xecnh thức thanh to\xe1n khi nhận h\xe0ng (COD) \xe1p dụng tại tất cả c\xe1c tỉnh th\xe0nh "
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                    children: "Bạn c\xf3 thể chọn “Thanh to\xe1n khi giao h\xe0ng (COD)” hoặc “Chuyển khoản qua ng\xe2n h\xe0ng” hoặc “Thanh to\xe1n bằng ATD”, t\xf9y theo nhu cầu của bạn."
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                    children: "Đối với tất cả c\xe1c đơn h\xe0ng kh\xf4ng căn cứ v\xe0o gi\xe1 trị sản phẩm hoặc vị tr\xed nhận h\xe0ng của kh\xe1ch h\xe0ng ph\xed vận chuyển được t\xednh theo mức ph\xed của h\xe3ng chuyển ph\xe1t."
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("b", {
                                            children: companyName
                                        }),
                                        " sẽ th\xf4ng b\xe1o tới qu\xfd kh\xe1ch ph\xed vận chuyển trước khi thực hiện vận chuyển"
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                    children: "Trường hợp thanh to\xe1n qua t\xe0i khoản ng\xe2n h\xe0ng. Bạn tiến h\xe0nh thanh to\xe1n v\xe0o t\xe0i khoản sau:"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                    children: [
                                        "Số T\xe0i Khoản: ",
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("b", {
                                            children: "896.88888"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                    children: [
                                        " ",
                                        "T\xean Chủ T\xe0i Khoản: ",
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("b", {
                                            children: "Nguyễn Anh Thư"
                                        }),
                                        " "
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                    children: [
                                        "Ng\xe2n h\xe0ng: ",
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("b", {
                                            children: "Vietinbank"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                    children: [
                                        'Nội dung chuyển khoản: "Thanh to\xe1n m\xe3 đơn h\xe0ng: ',
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("b", {
                                            children: "M\xe3 Đơn H\xe0ng"
                                        }),
                                        "“."
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                    children: "Mọi thắc mắc xin vui l\xf2ng li\xean hệ: 033 333 6789"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                    className: "tw-font-semibold tw-mt-3",
                                    children: "* Ch\xednh s\xe1ch mua trả g\xf3p v\xe0 thanh to\xe1n từ xa qua thẻ t\xedn dụng:"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                    children: "An Thư li\xean kết với b\xean thứ 3 để hỗ trợ Kh\xe1ch H\xe0ng mua h\xe0ng trả g\xf3p v\xe0 thanh to\xe1n từ xa qua thẻ t\xedn dụng. V\xec vậy, Kh\xe1ch H\xe0ng h\xe3y li\xean hệ với hệ thống kim cương An Thư để được tư vấn t\xf9y theo từng thời điểm."
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};
var __N_SSP = true;
/* harmony default export */ __webpack_exports__["default"] = (PaymentGuidePolicyPage);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,2888,179], function() { return __webpack_exec__(89866); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);